import { styled } from '@mui/material';

const Root = styled('div')({
  marginTop: 20,
  position: 'relative',
  paddingLeft: 30,
});

const Scheme = styled('div')({
  position: 'absolute',
  top: 0,
  left: 30,
  margin: 2,
  width: 'calc(100% - 30px)',
  height: 216,
  pointerEvents: 'none',
});

const TimelineWrapper = styled('div')({
  position: 'relative',
  margin: '0 -10px',
});

const Timeline = styled('input')`
  -webkit-appearance: none;
  width: 100%;
  height: 216px;
  background: transparent;
  &:focus {
    outline: none;
  }

  &::-webkit-slider-thumb {
    position: relative;
    z-index: 99;
    -webkit-appearance: none;
    cursor: pointer;
    width: 19px;
    height: 216px;
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjE2IiB2aWV3Qm94PSIwIDAgMTkgMjE2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSI5IiB5PSIyNCIgd2lkdGg9IjEiIGhlaWdodD0iMTkyIiBmaWxsPSIjNDU3QUIyIi8+CjxwYXRoIGQ9Ik0wIDAuOTk5OTk5QzAgMC40NDc3MTUgMC40NDc3MTUgMCAxIDBIMThDMTguNTUyMyAwIDE5IDAuNDQ3NzE1IDE5IDFWMTMuNDE3MUMxOSAxMy42MTEgMTguOTQzNiAxMy44MDA4IDE4LjgzNzcgMTMuOTYzMkwxMi41OSAyMy41NDYxQzEyLjQwNTQgMjMuODI5MyAxMi4wOTAzIDI0IDExLjc1MjMgMjRINy4yNDc2OEM2LjkwOTY5IDI0IDYuNTk0NTcgMjMuODI5MyA2LjQwOTk5IDIzLjU0NjFMMC4xNjIzMDggMTMuOTYzMkMwLjA1NjM5MjEgMTMuODAwOCAwIDEzLjYxMSAwIDEzLjQxNzFWMC45OTk5OTlaIiBmaWxsPSIjNDU3QUIyIi8+CjxwYXRoIGQ9Ik0xIDAuNUgxOEMxOC4yNzYxIDAuNSAxOC41IDAuNzIzODU3IDE4LjUgMVYxMy40MTcxQzE4LjUgMTMuNTE0MSAxOC40NzE4IDEzLjYwODkgMTguNDE4OCAxMy42OTAyTDEyLjE3MTIgMjMuMjczMUMxMi4wNzg5IDIzLjQxNDYgMTEuOTIxMyAyMy41IDExLjc1MjMgMjMuNUg3LjI0NzY4QzcuMDc4NjggMjMuNSA2LjkyMTEzIDIzLjQxNDYgNi44Mjg4MyAyMy4yNzMxTDAuNTgxMTU0IDEzLjY5MDJDMC41MjgxOTYgMTMuNjA4OSAwLjUgMTMuNTE0MSAwLjUgMTMuNDE3MVYxQzAuNSAwLjcyMzg1NyAwLjcyMzg1NyAwLjUgMSAwLjVaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utb3BhY2l0eT0iMC4zMiIvPgo8cmVjdCB4PSI5IiB5PSIxMiIgd2lkdGg9IjEiIGhlaWdodD0iMTIiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=');
  }

  &::-ms-track {
    height: 216px;
    width: 100%;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }

  &::-moz-range-track {
    background-color: transparent;
  }

  &::-moz-range-thumb {
    cursor: pointer;
    width: 19px;
    height: 216px;
    background-color: transparent;
    border: none;
    border-radius: 0;
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjE2IiB2aWV3Qm94PSIwIDAgMTkgMjE2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSI5IiB5PSIyNCIgd2lkdGg9IjEiIGhlaWdodD0iMTkyIiBmaWxsPSIjNDU3QUIyIi8+CjxwYXRoIGQ9Ik0wIDAuOTk5OTk5QzAgMC40NDc3MTUgMC40NDc3MTUgMCAxIDBIMThDMTguNTUyMyAwIDE5IDAuNDQ3NzE1IDE5IDFWMTMuNDE3MUMxOSAxMy42MTEgMTguOTQzNiAxMy44MDA4IDE4LjgzNzcgMTMuOTYzMkwxMi41OSAyMy41NDYxQzEyLjQwNTQgMjMuODI5MyAxMi4wOTAzIDI0IDExLjc1MjMgMjRINy4yNDc2OEM2LjkwOTY5IDI0IDYuNTk0NTcgMjMuODI5MyA2LjQwOTk5IDIzLjU0NjFMMC4xNjIzMDggMTMuOTYzMkMwLjA1NjM5MjEgMTMuODAwOCAwIDEzLjYxMSAwIDEzLjQxNzFWMC45OTk5OTlaIiBmaWxsPSIjNDU3QUIyIi8+CjxwYXRoIGQ9Ik0xIDAuNUgxOEMxOC4yNzYxIDAuNSAxOC41IDAuNzIzODU3IDE4LjUgMVYxMy40MTcxQzE4LjUgMTMuNTE0MSAxOC40NzE4IDEzLjYwODkgMTguNDE4OCAxMy42OTAyTDEyLjE3MTIgMjMuMjczMUMxMi4wNzg5IDIzLjQxNDYgMTEuOTIxMyAyMy41IDExLjc1MjMgMjMuNUg3LjI0NzY4QzcuMDc4NjggMjMuNSA2LjkyMTEzIDIzLjQxNDYgNi44Mjg4MyAyMy4yNzMxTDAuNTgxMTU0IDEzLjY5MDJDMC41MjgxOTYgMTMuNjA4OSAwLjUgMTMuNTE0MSAwLjUgMTMuNDE3MVYxQzAuNSAwLjcyMzg1NyAwLjcyMzg1NyAwLjUgMSAwLjVaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utb3BhY2l0eT0iMC4zMiIvPgo8cmVjdCB4PSI5IiB5PSIxMiIgd2lkdGg9IjEiIGhlaWdodD0iMTIiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=');
  }

  &::-ms-thumb {
    cursor: pointer;
    width: 19px;
    height: 216px;
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjE2IiB2aWV3Qm94PSIwIDAgMTkgMjE2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSI5IiB5PSIyNCIgd2lkdGg9IjEiIGhlaWdodD0iMTkyIiBmaWxsPSIjNDU3QUIyIi8+CjxwYXRoIGQ9Ik0wIDAuOTk5OTk5QzAgMC40NDc3MTUgMC40NDc3MTUgMCAxIDBIMThDMTguNTUyMyAwIDE5IDAuNDQ3NzE1IDE5IDFWMTMuNDE3MUMxOSAxMy42MTEgMTguOTQzNiAxMy44MDA4IDE4LjgzNzcgMTMuOTYzMkwxMi41OSAyMy41NDYxQzEyLjQwNTQgMjMuODI5MyAxMi4wOTAzIDI0IDExLjc1MjMgMjRINy4yNDc2OEM2LjkwOTY5IDI0IDYuNTk0NTcgMjMuODI5MyA2LjQwOTk5IDIzLjU0NjFMMC4xNjIzMDggMTMuOTYzMkMwLjA1NjM5MjEgMTMuODAwOCAwIDEzLjYxMSAwIDEzLjQxNzFWMC45OTk5OTlaIiBmaWxsPSIjNDU3QUIyIi8+CjxwYXRoIGQ9Ik0xIDAuNUgxOEMxOC4yNzYxIDAuNSAxOC41IDAuNzIzODU3IDE4LjUgMVYxMy40MTcxQzE4LjUgMTMuNTE0MSAxOC40NzE4IDEzLjYwODkgMTguNDE4OCAxMy42OTAyTDEyLjE3MTIgMjMuMjczMUMxMi4wNzg5IDIzLjQxNDYgMTEuOTIxMyAyMy41IDExLjc1MjMgMjMuNUg3LjI0NzY4QzcuMDc4NjggMjMuNSA2LjkyMTEzIDIzLjQxNDYgNi44Mjg4MyAyMy4yNzMxTDAuNTgxMTU0IDEzLjY5MDJDMC41MjgxOTYgMTMuNjA4OSAwLjUgMTMuNTE0MSAwLjUgMTMuNDE3MVYxQzAuNSAwLjcyMzg1NyAwLjcyMzg1NyAwLjUgMSAwLjVaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utb3BhY2l0eT0iMC4zMiIvPgo8cmVjdCB4PSI5IiB5PSIxMiIgd2lkdGg9IjEiIGhlaWdodD0iMTIiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=');
  }
`;

const Region = styled('div')({
  cursor: 'pointer',
  minWidth: '.25%',
  position: 'absolute',
  top: 0,
  height: 8,
  backgroundColor: '#c26aec',
});

const Anomaly = styled('div')({
  cursor: 'pointer',
  minWidth: '.25%',
  position: 'absolute',
  top: 0,
  height: 24,
  backgroundColor: '#e42519',
  pointerEvents: 'auto',
});

const Ticks = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '6px',
  left: 0,
  width: '100%',
  height: '24px',
  border: `1px solid ${theme.palette.black.main}`,
  borderTop: 'none',
  color: theme.palette.black.main,
  fontSize: '12px',
  lineHeight: '16px',
}));

const Tick = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  height: 24,
  '&::before': {
    content: '""',
    borderLeft: `1px solid ${theme.palette.black.main}`,
    position: 'absolute',
    bottom: 0,
    left: '50%',
    height: 8,
  },
}));

const SchemeContainer = styled('div')({
  position: 'relative',
  top: 50,
});

const IconWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'small',
})<{ small?: boolean }>(({ small }) => ({
  position: 'absolute',
  zIndex: 1,
  top: small ? -6 : 3,
  left: -30,
}));

const IconStyles = {
  width: 20,
  transform: 'scale(1.3)',
};

const AnomaliesWrapper = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
});

const Track = styled('div', {
  shouldForwardProp: (prop) => prop !== 'type',
})<{ type: 'alert' | 'camera' | 'screen' | 'sound' }>(({ theme, type }) => ({
  position: 'relative',
  height: type === 'alert' ? 8 : 24,
  width: '100%',
  marginBottom: type === 'alert' ? 20 : 16,
  backgroundColor:
    type === 'screen' ? '#fbeed8' : type === 'sound' ? '#e3fbe6' : theme.palette.grey[100],
  cursor: 'pointer',
  zIndex: 99,
}));

export {
  SchemeContainer,
  Ticks,
  Tick,
  Region,
  Anomaly,
  Root,
  Track,
  Scheme,
  TimelineWrapper,
  Timeline,
  IconWrapper,
  IconStyles,
  AnomaliesWrapper,
};
